// Unicode CLDR 48.0.0 English territories, checked 2026-10-14.
// https://github.com/unicode-org/cldr-json/blob/48.0.0/cldr-json/cldr-localenames-full/main/en/territories.json
// All two-letter territorial entries except EU/EZ/QO/UN (groupings), XA/XB
// (test locales), ZZ (unknown); retain the existing Other choice and legacy labels.
// Names remain the profile persistence contract. This does not alter dial codes.
export interface ProfileCountry { code: string; name: string; aliases: string[] }
const catalogue: ProfileCountry[] = [
  {
    "code": "AC",
    "name": "Ascension Island",
    "aliases": []
  },
  {
    "code": "AD",
    "name": "Andorra",
    "aliases": []
  },
  {
    "code": "AE",
    "name": "United Arab Emirates",
    "aliases": []
  },
  {
    "code": "AF",
    "name": "Afghanistan",
    "aliases": []
  },
  {
    "code": "AG",
    "name": "Antigua and Barbuda",
    "aliases": [
      "Antigua & Barbuda"
    ]
  },
  {
    "code": "AI",
    "name": "Anguilla",
    "aliases": []
  },
  {
    "code": "AL",
    "name": "Albania",
    "aliases": []
  },
  {
    "code": "AM",
    "name": "Armenia",
    "aliases": []
  },
  {
    "code": "AO",
    "name": "Angola",
    "aliases": []
  },
  {
    "code": "AQ",
    "name": "Antarctica",
    "aliases": []
  },
  {
    "code": "AR",
    "name": "Argentina",
    "aliases": []
  },
  {
    "code": "AS",
    "name": "American Samoa",
    "aliases": []
  },
  {
    "code": "AT",
    "name": "Austria",
    "aliases": []
  },
  {
    "code": "AU",
    "name": "Australia",
    "aliases": []
  },
  {
    "code": "AW",
    "name": "Aruba",
    "aliases": []
  },
  {
    "code": "AX",
    "name": "Åland Islands",
    "aliases": []
  },
  {
    "code": "AZ",
    "name": "Azerbaijan",
    "aliases": []
  },
  {
    "code": "BA",
    "name": "Bosnia & Herzegovina",
    "aliases": [
      "Bosnia"
    ]
  },
  {
    "code": "BB",
    "name": "Barbados",
    "aliases": []
  },
  {
    "code": "BD",
    "name": "Bangladesh",
    "aliases": []
  },
  {
    "code": "BE",
    "name": "Belgium",
    "aliases": []
  },
  {
    "code": "BF",
    "name": "Burkina Faso",
    "aliases": []
  },
  {
    "code": "BG",
    "name": "Bulgaria",
    "aliases": []
  },
  {
    "code": "BH",
    "name": "Bahrain",
    "aliases": []
  },
  {
    "code": "BI",
    "name": "Burundi",
    "aliases": []
  },
  {
    "code": "BJ",
    "name": "Benin",
    "aliases": []
  },
  {
    "code": "BL",
    "name": "St. Barthélemy",
    "aliases": []
  },
  {
    "code": "BM",
    "name": "Bermuda",
    "aliases": []
  },
  {
    "code": "BN",
    "name": "Brunei",
    "aliases": []
  },
  {
    "code": "BO",
    "name": "Bolivia",
    "aliases": []
  },
  {
    "code": "BQ",
    "name": "Caribbean Netherlands",
    "aliases": []
  },
  {
    "code": "BR",
    "name": "Brazil",
    "aliases": []
  },
  {
    "code": "BS",
    "name": "Bahamas",
    "aliases": []
  },
  {
    "code": "BT",
    "name": "Bhutan",
    "aliases": []
  },
  {
    "code": "BV",
    "name": "Bouvet Island",
    "aliases": []
  },
  {
    "code": "BW",
    "name": "Botswana",
    "aliases": []
  },
  {
    "code": "BY",
    "name": "Belarus",
    "aliases": []
  },
  {
    "code": "BZ",
    "name": "Belize",
    "aliases": []
  },
  {
    "code": "CA",
    "name": "Canada",
    "aliases": []
  },
  {
    "code": "CC",
    "name": "Cocos (Keeling) Islands",
    "aliases": [
      "Cocos Islands"
    ]
  },
  {
    "code": "CD",
    "name": "Democratic Republic of the Congo",
    "aliases": [
      "Congo (DRC)",
      "Congo - Kinshasa"
    ]
  },
  {
    "code": "CF",
    "name": "Central African Republic",
    "aliases": []
  },
  {
    "code": "CG",
    "name": "Republic of the Congo",
    "aliases": [
      "Congo (Republic)",
      "Congo - Brazzaville"
    ]
  },
  {
    "code": "CH",
    "name": "Switzerland",
    "aliases": []
  },
  {
    "code": "CI",
    "name": "Côte d’Ivoire",
    "aliases": [
      "Ivory Coast"
    ]
  },
  {
    "code": "CK",
    "name": "Cook Islands",
    "aliases": []
  },
  {
    "code": "CL",
    "name": "Chile",
    "aliases": []
  },
  {
    "code": "CM",
    "name": "Cameroon",
    "aliases": []
  },
  {
    "code": "CN",
    "name": "China",
    "aliases": []
  },
  {
    "code": "CO",
    "name": "Colombia",
    "aliases": []
  },
  {
    "code": "CP",
    "name": "Clipperton Island",
    "aliases": []
  },
  {
    "code": "CQ",
    "name": "Sark",
    "aliases": []
  },
  {
    "code": "CR",
    "name": "Costa Rica",
    "aliases": []
  },
  {
    "code": "CU",
    "name": "Cuba",
    "aliases": []
  },
  {
    "code": "CV",
    "name": "Cape Verde",
    "aliases": [
      "Cabo Verde"
    ]
  },
  {
    "code": "CW",
    "name": "Curaçao",
    "aliases": []
  },
  {
    "code": "CX",
    "name": "Christmas Island",
    "aliases": []
  },
  {
    "code": "CY",
    "name": "Cyprus",
    "aliases": []
  },
  {
    "code": "CZ",
    "name": "Czech Republic",
    "aliases": [
      "Czech Republic",
      "Czechia"
    ]
  },
  {
    "code": "DE",
    "name": "Germany",
    "aliases": []
  },
  {
    "code": "DG",
    "name": "Diego Garcia",
    "aliases": []
  },
  {
    "code": "DJ",
    "name": "Djibouti",
    "aliases": []
  },
  {
    "code": "DK",
    "name": "Denmark",
    "aliases": []
  },
  {
    "code": "DM",
    "name": "Dominica",
    "aliases": []
  },
  {
    "code": "DO",
    "name": "Dominican Republic",
    "aliases": []
  },
  {
    "code": "DZ",
    "name": "Algeria",
    "aliases": []
  },
  {
    "code": "EA",
    "name": "Ceuta & Melilla",
    "aliases": []
  },
  {
    "code": "EC",
    "name": "Ecuador",
    "aliases": []
  },
  {
    "code": "EE",
    "name": "Estonia",
    "aliases": []
  },
  {
    "code": "EG",
    "name": "Egypt",
    "aliases": []
  },
  {
    "code": "EH",
    "name": "Western Sahara",
    "aliases": []
  },
  {
    "code": "ER",
    "name": "Eritrea",
    "aliases": []
  },
  {
    "code": "ES",
    "name": "Spain",
    "aliases": []
  },
  {
    "code": "ET",
    "name": "Ethiopia",
    "aliases": []
  },
  {
    "code": "FI",
    "name": "Finland",
    "aliases": []
  },
  {
    "code": "FJ",
    "name": "Fiji",
    "aliases": []
  },
  {
    "code": "FK",
    "name": "Falkland Islands",
    "aliases": [
      "Falkland Islands (Islas Malvinas)"
    ]
  },
  {
    "code": "FM",
    "name": "Micronesia",
    "aliases": []
  },
  {
    "code": "FO",
    "name": "Faroe Islands",
    "aliases": []
  },
  {
    "code": "FR",
    "name": "France",
    "aliases": []
  },
  {
    "code": "GA",
    "name": "Gabon",
    "aliases": []
  },
  {
    "code": "GB",
    "name": "United Kingdom",
    "aliases": [
      "UK"
    ]
  },
  {
    "code": "GD",
    "name": "Grenada",
    "aliases": []
  },
  {
    "code": "GE",
    "name": "Georgia",
    "aliases": []
  },
  {
    "code": "GF",
    "name": "French Guiana",
    "aliases": []
  },
  {
    "code": "GG",
    "name": "Guernsey",
    "aliases": []
  },
  {
    "code": "GH",
    "name": "Ghana",
    "aliases": []
  },
  {
    "code": "GI",
    "name": "Gibraltar",
    "aliases": []
  },
  {
    "code": "GL",
    "name": "Greenland",
    "aliases": []
  },
  {
    "code": "GM",
    "name": "Gambia",
    "aliases": []
  },
  {
    "code": "GN",
    "name": "Guinea",
    "aliases": []
  },
  {
    "code": "GP",
    "name": "Guadeloupe",
    "aliases": []
  },
  {
    "code": "GQ",
    "name": "Equatorial Guinea",
    "aliases": []
  },
  {
    "code": "GR",
    "name": "Greece",
    "aliases": []
  },
  {
    "code": "GS",
    "name": "South Georgia & South Sandwich Islands",
    "aliases": []
  },
  {
    "code": "GT",
    "name": "Guatemala",
    "aliases": []
  },
  {
    "code": "GU",
    "name": "Guam",
    "aliases": []
  },
  {
    "code": "GW",
    "name": "Guinea-Bissau",
    "aliases": []
  },
  {
    "code": "GY",
    "name": "Guyana",
    "aliases": []
  },
  {
    "code": "HK",
    "name": "Hong Kong SAR China",
    "aliases": [
      "Hong Kong"
    ]
  },
  {
    "code": "HM",
    "name": "Heard & McDonald Islands",
    "aliases": []
  },
  {
    "code": "HN",
    "name": "Honduras",
    "aliases": []
  },
  {
    "code": "HR",
    "name": "Croatia",
    "aliases": []
  },
  {
    "code": "HT",
    "name": "Haiti",
    "aliases": []
  },
  {
    "code": "HU",
    "name": "Hungary",
    "aliases": []
  },
  {
    "code": "IC",
    "name": "Canary Islands",
    "aliases": []
  },
  {
    "code": "ID",
    "name": "Indonesia",
    "aliases": []
  },
  {
    "code": "IE",
    "name": "Ireland",
    "aliases": []
  },
  {
    "code": "IL",
    "name": "Israel",
    "aliases": []
  },
  {
    "code": "IM",
    "name": "Isle of Man",
    "aliases": []
  },
  {
    "code": "IN",
    "name": "India",
    "aliases": []
  },
  {
    "code": "IO",
    "name": "British Indian Ocean Territory",
    "aliases": [
      "Chagos Archipelago"
    ]
  },
  {
    "code": "IQ",
    "name": "Iraq",
    "aliases": []
  },
  {
    "code": "IR",
    "name": "Iran",
    "aliases": []
  },
  {
    "code": "IS",
    "name": "Iceland",
    "aliases": []
  },
  {
    "code": "IT",
    "name": "Italy",
    "aliases": []
  },
  {
    "code": "JE",
    "name": "Jersey",
    "aliases": []
  },
  {
    "code": "JM",
    "name": "Jamaica",
    "aliases": []
  },
  {
    "code": "JO",
    "name": "Jordan",
    "aliases": []
  },
  {
    "code": "JP",
    "name": "Japan",
    "aliases": []
  },
  {
    "code": "KE",
    "name": "Kenya",
    "aliases": []
  },
  {
    "code": "KG",
    "name": "Kyrgyzstan",
    "aliases": []
  },
  {
    "code": "KH",
    "name": "Cambodia",
    "aliases": []
  },
  {
    "code": "KI",
    "name": "Kiribati",
    "aliases": []
  },
  {
    "code": "KM",
    "name": "Comoros",
    "aliases": []
  },
  {
    "code": "KN",
    "name": "Saint Kitts and Nevis",
    "aliases": [
      "St. Kitts & Nevis"
    ]
  },
  {
    "code": "KP",
    "name": "North Korea",
    "aliases": []
  },
  {
    "code": "KR",
    "name": "South Korea",
    "aliases": []
  },
  {
    "code": "KW",
    "name": "Kuwait",
    "aliases": []
  },
  {
    "code": "KY",
    "name": "Cayman Islands",
    "aliases": []
  },
  {
    "code": "KZ",
    "name": "Kazakhstan",
    "aliases": []
  },
  {
    "code": "LA",
    "name": "Laos",
    "aliases": []
  },
  {
    "code": "LB",
    "name": "Lebanon",
    "aliases": []
  },
  {
    "code": "LC",
    "name": "Saint Lucia",
    "aliases": [
      "St. Lucia"
    ]
  },
  {
    "code": "LI",
    "name": "Liechtenstein",
    "aliases": []
  },
  {
    "code": "LK",
    "name": "Sri Lanka",
    "aliases": []
  },
  {
    "code": "LR",
    "name": "Liberia",
    "aliases": []
  },
  {
    "code": "LS",
    "name": "Lesotho",
    "aliases": []
  },
  {
    "code": "LT",
    "name": "Lithuania",
    "aliases": []
  },
  {
    "code": "LU",
    "name": "Luxembourg",
    "aliases": []
  },
  {
    "code": "LV",
    "name": "Latvia",
    "aliases": []
  },
  {
    "code": "LY",
    "name": "Libya",
    "aliases": []
  },
  {
    "code": "MA",
    "name": "Morocco",
    "aliases": []
  },
  {
    "code": "MC",
    "name": "Monaco",
    "aliases": []
  },
  {
    "code": "MD",
    "name": "Moldova",
    "aliases": []
  },
  {
    "code": "ME",
    "name": "Montenegro",
    "aliases": []
  },
  {
    "code": "MF",
    "name": "St. Martin",
    "aliases": []
  },
  {
    "code": "MG",
    "name": "Madagascar",
    "aliases": []
  },
  {
    "code": "MH",
    "name": "Marshall Islands",
    "aliases": []
  },
  {
    "code": "MK",
    "name": "North Macedonia",
    "aliases": []
  },
  {
    "code": "ML",
    "name": "Mali",
    "aliases": []
  },
  {
    "code": "MM",
    "name": "Myanmar (Burma)",
    "aliases": [
      "Myanmar"
    ]
  },
  {
    "code": "MN",
    "name": "Mongolia",
    "aliases": []
  },
  {
    "code": "MO",
    "name": "Macao SAR China",
    "aliases": [
      "Macao"
    ]
  },
  {
    "code": "MP",
    "name": "Northern Mariana Islands",
    "aliases": []
  },
  {
    "code": "MQ",
    "name": "Martinique",
    "aliases": []
  },
  {
    "code": "MR",
    "name": "Mauritania",
    "aliases": []
  },
  {
    "code": "MS",
    "name": "Montserrat",
    "aliases": []
  },
  {
    "code": "MT",
    "name": "Malta",
    "aliases": []
  },
  {
    "code": "MU",
    "name": "Mauritius",
    "aliases": []
  },
  {
    "code": "MV",
    "name": "Maldives",
    "aliases": []
  },
  {
    "code": "MW",
    "name": "Malawi",
    "aliases": []
  },
  {
    "code": "MX",
    "name": "Mexico",
    "aliases": []
  },
  {
    "code": "MY",
    "name": "Malaysia",
    "aliases": []
  },
  {
    "code": "MZ",
    "name": "Mozambique",
    "aliases": []
  },
  {
    "code": "NA",
    "name": "Namibia",
    "aliases": []
  },
  {
    "code": "NC",
    "name": "New Caledonia",
    "aliases": []
  },
  {
    "code": "NE",
    "name": "Niger",
    "aliases": []
  },
  {
    "code": "NF",
    "name": "Norfolk Island",
    "aliases": []
  },
  {
    "code": "NG",
    "name": "Nigeria",
    "aliases": []
  },
  {
    "code": "NI",
    "name": "Nicaragua",
    "aliases": []
  },
  {
    "code": "NL",
    "name": "Netherlands",
    "aliases": []
  },
  {
    "code": "NO",
    "name": "Norway",
    "aliases": []
  },
  {
    "code": "NP",
    "name": "Nepal",
    "aliases": []
  },
  {
    "code": "NR",
    "name": "Nauru",
    "aliases": []
  },
  {
    "code": "NU",
    "name": "Niue",
    "aliases": []
  },
  {
    "code": "NZ",
    "name": "New Zealand",
    "aliases": [
      "Aotearoa New Zealand"
    ]
  },
  {
    "code": "OM",
    "name": "Oman",
    "aliases": []
  },
  {
    "code": "PA",
    "name": "Panama",
    "aliases": []
  },
  {
    "code": "PE",
    "name": "Peru",
    "aliases": []
  },
  {
    "code": "PF",
    "name": "French Polynesia",
    "aliases": []
  },
  {
    "code": "PG",
    "name": "Papua New Guinea",
    "aliases": []
  },
  {
    "code": "PH",
    "name": "Philippines",
    "aliases": []
  },
  {
    "code": "PK",
    "name": "Pakistan",
    "aliases": []
  },
  {
    "code": "PL",
    "name": "Poland",
    "aliases": []
  },
  {
    "code": "PM",
    "name": "St. Pierre & Miquelon",
    "aliases": []
  },
  {
    "code": "PN",
    "name": "Pitcairn Islands",
    "aliases": [
      "Pitcairn"
    ]
  },
  {
    "code": "PR",
    "name": "Puerto Rico",
    "aliases": []
  },
  {
    "code": "PS",
    "name": "Palestinian Territories",
    "aliases": [
      "Palestine"
    ]
  },
  {
    "code": "PT",
    "name": "Portugal",
    "aliases": []
  },
  {
    "code": "PW",
    "name": "Palau",
    "aliases": []
  },
  {
    "code": "PY",
    "name": "Paraguay",
    "aliases": []
  },
  {
    "code": "QA",
    "name": "Qatar",
    "aliases": []
  },
  {
    "code": "RE",
    "name": "Réunion",
    "aliases": []
  },
  {
    "code": "RO",
    "name": "Romania",
    "aliases": []
  },
  {
    "code": "RS",
    "name": "Serbia",
    "aliases": []
  },
  {
    "code": "RU",
    "name": "Russia",
    "aliases": []
  },
  {
    "code": "RW",
    "name": "Rwanda",
    "aliases": []
  },
  {
    "code": "SA",
    "name": "Saudi Arabia",
    "aliases": []
  },
  {
    "code": "SB",
    "name": "Solomon Islands",
    "aliases": []
  },
  {
    "code": "SC",
    "name": "Seychelles",
    "aliases": []
  },
  {
    "code": "SD",
    "name": "Sudan",
    "aliases": []
  },
  {
    "code": "SE",
    "name": "Sweden",
    "aliases": []
  },
  {
    "code": "SG",
    "name": "Singapore",
    "aliases": []
  },
  {
    "code": "SH",
    "name": "St. Helena",
    "aliases": []
  },
  {
    "code": "SI",
    "name": "Slovenia",
    "aliases": []
  },
  {
    "code": "SJ",
    "name": "Svalbard & Jan Mayen",
    "aliases": []
  },
  {
    "code": "SK",
    "name": "Slovakia",
    "aliases": []
  },
  {
    "code": "SL",
    "name": "Sierra Leone",
    "aliases": []
  },
  {
    "code": "SM",
    "name": "San Marino",
    "aliases": []
  },
  {
    "code": "SN",
    "name": "Senegal",
    "aliases": []
  },
  {
    "code": "SO",
    "name": "Somalia",
    "aliases": []
  },
  {
    "code": "SR",
    "name": "Suriname",
    "aliases": []
  },
  {
    "code": "SS",
    "name": "South Sudan",
    "aliases": []
  },
  {
    "code": "ST",
    "name": "São Tomé and Príncipe",
    "aliases": [
      "São Tomé & Príncipe"
    ]
  },
  {
    "code": "SV",
    "name": "El Salvador",
    "aliases": []
  },
  {
    "code": "SX",
    "name": "Sint Maarten",
    "aliases": []
  },
  {
    "code": "SY",
    "name": "Syria",
    "aliases": []
  },
  {
    "code": "SZ",
    "name": "Eswatini",
    "aliases": [
      "Swaziland"
    ]
  },
  {
    "code": "TA",
    "name": "Tristan da Cunha",
    "aliases": []
  },
  {
    "code": "TC",
    "name": "Turks & Caicos Islands",
    "aliases": []
  },
  {
    "code": "TD",
    "name": "Chad",
    "aliases": []
  },
  {
    "code": "TF",
    "name": "French Southern Territories",
    "aliases": []
  },
  {
    "code": "TG",
    "name": "Togo",
    "aliases": []
  },
  {
    "code": "TH",
    "name": "Thailand",
    "aliases": []
  },
  {
    "code": "TJ",
    "name": "Tajikistan",
    "aliases": []
  },
  {
    "code": "TK",
    "name": "Tokelau",
    "aliases": []
  },
  {
    "code": "TL",
    "name": "Timor-Leste",
    "aliases": [
      "East Timor"
    ]
  },
  {
    "code": "TM",
    "name": "Turkmenistan",
    "aliases": []
  },
  {
    "code": "TN",
    "name": "Tunisia",
    "aliases": []
  },
  {
    "code": "TO",
    "name": "Tonga",
    "aliases": []
  },
  {
    "code": "TR",
    "name": "Turkey",
    "aliases": [
      "Turkey",
      "Türkiye"
    ]
  },
  {
    "code": "TT",
    "name": "Trinidad and Tobago",
    "aliases": [
      "Trinidad & Tobago"
    ]
  },
  {
    "code": "TV",
    "name": "Tuvalu",
    "aliases": []
  },
  {
    "code": "TW",
    "name": "Taiwan",
    "aliases": []
  },
  {
    "code": "TZ",
    "name": "Tanzania",
    "aliases": []
  },
  {
    "code": "UA",
    "name": "Ukraine",
    "aliases": []
  },
  {
    "code": "UG",
    "name": "Uganda",
    "aliases": []
  },
  {
    "code": "UM",
    "name": "U.S. Outlying Islands",
    "aliases": []
  },
  {
    "code": "US",
    "name": "United States",
    "aliases": [
      "US"
    ]
  },
  {
    "code": "UY",
    "name": "Uruguay",
    "aliases": []
  },
  {
    "code": "UZ",
    "name": "Uzbekistan",
    "aliases": []
  },
  {
    "code": "VA",
    "name": "Vatican City",
    "aliases": []
  },
  {
    "code": "VC",
    "name": "Saint Vincent and the Grenadines",
    "aliases": [
      "St. Vincent & Grenadines"
    ]
  },
  {
    "code": "VE",
    "name": "Venezuela",
    "aliases": []
  },
  {
    "code": "VG",
    "name": "British Virgin Islands",
    "aliases": []
  },
  {
    "code": "VI",
    "name": "U.S. Virgin Islands",
    "aliases": []
  },
  {
    "code": "VN",
    "name": "Vietnam",
    "aliases": []
  },
  {
    "code": "VU",
    "name": "Vanuatu",
    "aliases": []
  },
  {
    "code": "WF",
    "name": "Wallis & Futuna",
    "aliases": []
  },
  {
    "code": "WS",
    "name": "Samoa",
    "aliases": []
  },
  {
    "code": "XK",
    "name": "Kosovo",
    "aliases": []
  },
  {
    "code": "YE",
    "name": "Yemen",
    "aliases": []
  },
  {
    "code": "YT",
    "name": "Mayotte",
    "aliases": []
  },
  {
    "code": "ZA",
    "name": "South Africa",
    "aliases": []
  },
  {
    "code": "ZM",
    "name": "Zambia",
    "aliases": []
  },
  {
    "code": "ZW",
    "name": "Zimbabwe",
    "aliases": []
  },
  {
    "code": "Other",
    "name": "Other",
    "aliases": []
  }
];
export const profileCountries = catalogue.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
export const normaliseCountrySearch = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
export const searchProfileCountries = (query: string) => {
  const term = normaliseCountrySearch(query);
  return profileCountries.filter(country => [country.name, country.code, ...country.aliases].some(label => normaliseCountrySearch(label).includes(term)));
};
